import { render } from "./BetRoom.vue?vue&type=template&id=25951cb0&scoped=true"
import script from "./BetRoom.vue?vue&type=script&lang=js"
export * from "./BetRoom.vue?vue&type=script&lang=js"

import "./BetRoom.vue?vue&type=style&index=0&id=25951cb0&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25951cb0"]])

export default __exports__